// extracted by mini-css-extract-plugin
export default {"Container":"Contact_Container__7LWLY","PageTitle":"Contact_PageTitle__py85m","LinkInIcon":"Contact_LinkInIcon__dc0VE","SendBtn":"Contact_SendBtn__cB-5z"};